import { useStore } from '~/store/store'
export default async ({ $pinia }) => {
  const store = useStore($pinia)
  store.nuxtServerInit()
}
